import { installAmplitude } from './track-script';
import { events as amplitude } from './amplitude';
import { createTrackReplayer } from '../util';

export class AmplitudeTracker {
  static create(opts, context) {
    return new AmplitudeTracker(opts, context);
  }

  constructor({ id, userId, customerId }, context) {
    this.name = 'amplitude';
    this.id = id;
    this.userId = userId;
    this.customerId = customerId || '';
    this.amplitudeEventSet = {};
    this.ready = false;

    if (!context.amplitude) installAmplitude(context);
    let count = 0;
    let tryTime = 3;
    // 3번까지만 돌리는 걸로... OTL
    const interval = setInterval(() => {
      count++;
      tryTime--;
      // installAmplitude에서 amplitude의 스크립트를 로드
      // 스크립트가 로드되기 전에 amplitude.getInstance().init을 하면 송신이 안됨
      // 이에 amplitude 스크립트 로드 -> amplitude.options가 생성된 것이 확인 될 때까지 대기
      if (tryTime && context.amplitude?.options) {
        this.amplitude = context.amplitude;
        this.amplitude.getInstance().init(id, userId, { includeReferrer: true, includeUtm: true });
        this.amplitudeEventSet = amplitude({
          tracker: this.amplitude,
          condition: { userId: this.userId, customerId: this.customerId },
        });
        this.ready = true;
        clearInterval(interval);
      } else if (tryTime <= 0) {
        clearInterval(interval);
      }
    }, 800 * Math.pow(2, count - 1));
  }

  track(event, data) {
    if (!this.ready) {
      if (process.env['NODE_ENV'] !== 'prod') console.error('**ignore** not ready!', event, data);
      const trackReplayer = createTrackReplayer({ target: this, time: 3 });
      trackReplayer(event, data);
    }

    if (this.amplitudeEventSet[event]) this.amplitudeEventSet[event](data);
  }
}
